import { TABLE_PAGINATION_SIZE_DEFAULT } from 'constants/table';
import { SensorEntityModel, SensorLinksModel, SensorListResponseModel, SensorMetaModel } from '../models/sensorEntityModels';
import { SensorLinksPayload, SensorListResponsePayload, SensorMetaPayload, SensorPayloadModel } from '../models/sensorPayloadModels';

export const payloadToSensorsAssets = ({
  id,
  uid,
  name,
  room,
  usage,
  sensor_type,
  are_values_accumulated,
  can_data_be_fetched,
  device_id,
  gateway_id,
  sensor_id,
  available_tags,
  tags,
}: SensorPayloadModel): SensorEntityModel => {
  return {
    id,
    uid,
    name: name ?? '',
    room: room ?? '',
    usage: usage ?? '',
    sensorType: sensor_type ?? '',
    areValuesAccumulated: are_values_accumulated,
    canDataBeFetched: can_data_be_fetched,
    deviceId: device_id ?? '',
    gatewayId: gateway_id ?? null,
    sensorId: sensor_id ?? '',
    availableTags: available_tags ?? [],
    tags: tags ?? [],
  };
};

const payloadToSensorListResponseMeta = ({ all_results, page_size, results, total_pages }: SensorMetaPayload): SensorMetaModel => {
  return {
    allResults: all_results ?? 0,
    pageSize: page_size ?? Number(TABLE_PAGINATION_SIZE_DEFAULT),
    results: results ?? 0,
    totalPages: total_pages ?? 1,
  };
};

const payloadToSensorListResponseLinks = ({ first, last, next, prev, self }: SensorLinksPayload): SensorLinksModel => {
  return {
    first: first ?? '',
    last: last ?? '',
    next: next ?? '',
    prev: prev ?? '',
    self: self ?? '',
  };
};

export const payloadToAssetSensorListResponse = (payload: SensorListResponsePayload): SensorListResponseModel => {
  const { data, meta, links } = payload;

  const transformedData = data.map((item) => payloadToSensorsAssets(item)) || [];
  const transformedMeta = !!meta ? payloadToSensorListResponseMeta(meta) : ({} as SensorMetaModel);
  const transformedLinks = !!links ? payloadToSensorListResponseLinks(links) : ({} as SensorLinksModel);

  return {
    data: transformedData,
    meta: transformedMeta,
    links: transformedLinks,
  };
};
